import { useColorModeValue, Avatar, Flex } from '@chakra-ui/react';
import React from 'react';

import { date as commonDate } from '@finley-technologies/common';

import { CommentGQLType } from 'types/dashboard-core-gqlTypes.generated.d';

import { useUserColor } from './useUserColor';
import { colors } from '~/packages/common-frontend/colors';
import { Icon } from '~/packages/common-frontend/components/icons';
import { RenderStaticHtml } from '~/packages/common-frontend/components/RichTextEditor/RichTextEditor';
import { Typography } from '~/packages/common-frontend/components/Typography';

// Exports
type CommentBoxProps = { comment: CommentGQLType; actions?: React.ReactNode };
export const CommentBox = ({ comment, actions }: CommentBoxProps) => {
  const textColor = useColorModeValue(colors.gray[800], colors.gray[100]);
  const circleColor = useUserColor(comment.authorUserId);
  return (
    <Flex direction="column" gap="0.75rem">
      <Flex alignItems="flex-start" gap="0.5rem">
        <Avatar
          height="2.5rem"
          width="2.5rem"
          size="md"
          background={circleColor}
          name={`${comment.authorFirstName} ${comment.authorLastName}`}
          icon={<Icon icon="user" size="1.5rem" />}
        />
        <Flex direction="column" flexGrow={1}>
          <Typography variant="detail" fontWeight="bold">
            {comment.authorFirstName} {comment.authorLastName},{' '}
            {comment.authorOrganizationName}
          </Typography>
          <Typography variant="detail-muted" colorScheme="gray">
            {commonDate.epochToLocaleDateString(comment.created_at)}
          </Typography>
        </Flex>
        <Flex gap="0.5rem">{actions}</Flex>
      </Flex>
      <RenderStaticHtml textHtml={comment.comment} color={textColor} />
    </Flex>
  );
};
